module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-ring-1-6ed5f1f41552ba85aa0db1543395fec2.svg";